"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSettingsEventTypes = void 0;
var ChatSettingsEventTypes;
(function (ChatSettingsEventTypes) {
    ChatSettingsEventTypes["ADD"] = "chat-settings-add";
    ChatSettingsEventTypes["UPDATE"] = "chat-settings-update";
})(ChatSettingsEventTypes || (exports.ChatSettingsEventTypes = ChatSettingsEventTypes = {}));
